const removeHTML = function (el, vnode) {
  const comment = document.createComment('');
  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined,
  });
  vnode.elm = comment;
  vnode.text = ' ';
  vnode.isComment = true;
  vnode.context = undefined;
  vnode.tag = undefined;
  vnode.data.directives = undefined;

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment;
  }

  if (el && el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}

const handleIfHaveNotPermission = function (el, binding, vnode) {
  removeHTML(el, vnode)

  if (binding.modifiers['notify']) {
    let vue = new Vue();
    vue.$forbidden();
  }
}

export default {
  install(Vue) {
    Vue.directive('hasPermission', {
      bind: function (el, binding, vnode) {
        let permissions = JSON.parse(localStorage.getItem('permissions'));
        let hasPermission = permissions.admin || permissions.permissions.indexOf(binding.value) > -1;
        if (!hasPermission) {
          handleIfHaveNotPermission(el, binding, vnode);
        }
      }
    });
    Vue.directive('hasAllPermission', {
      bind: function (el, binding, vnode) {
        let permissions = JSON.parse(localStorage.getItem('permissions'));
        let hasPermission = permissions.admin || binding.value.every(elem => permissions.permissions.indexOf(elem) > -1);
        if (!hasPermission) {
          handleIfHaveNotPermission(el, binding, vnode);
        }
      }
    });

    Vue.directive('hasAnyPermission', {
      bind: function (el, binding, vnode) {
        let permissions = JSON.parse(localStorage.getItem('permissions'));
        let hasPermission = permissions.admin || binding.value.some(elem => permissions.permissions.indexOf(elem) > -1);
        if (!hasPermission) {
          handleIfHaveNotPermission(el, binding, vnode);
        }
      }
    });
  }
}